import { setFetchNewSentencesLoading } from '@chegg-wt/core/state/paraphraser/actions'
import { FeedbackType, PaperStatus } from '@chegg-wt/core/types/paraphraser'
import {
  paperIdSelector,
  paperStatusSelector,
  sentenceOffsetsSelector,
} from '@chegg-wt/core/state/paraphraser/selectors'
import { Dispatch } from 'redux'
import { AppState } from '@chegg-wt/core/state/types'
import { CheckTypeInput } from '@chegg-wt/core/globalTypesOneGraph'
import pusherManager from '../../pusherManager'
import { newFeedbacksOnEditHandler } from '../../pusherDataHandlers'

export const addNewFeedbacks = async (
  grammarSentenceIds: Set<String>,
  paraphraseSentenceIds: Set<String>,
  state: AppState,
  dispatch: Dispatch
) => {
  if (grammarSentenceIds.size === 0 && paraphraseSentenceIds.size === 0) {
    // Optimization when we have no sentenceId to add
    return
  }
  const isDraftPaper = paperStatusSelector(state) === PaperStatus.DRAFT
  // We will not fetch sentences in draft state
  if (isDraftPaper) return
  const initiatedAt = new Date().toISOString()
  const paperId = paperIdSelector(state)
  const sentenceOffsets = sentenceOffsetsSelector(state)
  try {
    await newFeedbacksOnEditHandler.subscribeChannels(
      dispatch,
      grammarSentenceIds.size > 0 ? FeedbackType.GRAMMAR : FeedbackType.PARAPHRASE // This is pass just to select error message
    )
  } catch {
    // Do not precess sentences if not able to make pusher connection
    return
  }
  const traceId = await pusherManager.getTraceId()
  let setLoading = false

  const grammarSentences = sentenceOffsets
    .filter((sentence) => grammarSentenceIds.has(sentence.id))
    .map((sentence) => ({
      id: sentence.id,
      originalText: sentence.originalText,
    }))
  if (grammarSentences.length > 0) {
    const isSentencesAddedToGraphlCall = newFeedbacksOnEditHandler.addWaitAndMakeSentenceCheckCall(
      {
        sentences: grammarSentences,
        paperId,
        traceId,
        initiatedAt,
        checkType: CheckTypeInput.GRAMMAR,
        dispatch,
      }
    )
    if (isSentencesAddedToGraphlCall) setLoading = true
  }
  const paraphraseSentences = sentenceOffsets
    .filter((sentence) => paraphraseSentenceIds.has(sentence.id))
    .map((sentence) => ({
      id: sentence.id,
      originalText: sentence.originalText,
    }))
  if (paraphraseSentences.length > 0) {
    const isSentencesAddedToGraphlCall = newFeedbacksOnEditHandler.addWaitAndMakeSentenceCheckCall(
      {
        sentences: paraphraseSentences,
        paperId,
        traceId,
        initiatedAt,
        checkType: CheckTypeInput.PARAPHRASE,
        dispatch,
      }
    )
    if (isSentencesAddedToGraphlCall) setLoading = true
  }
  if (setLoading) dispatch(setFetchNewSentencesLoading(true))
}
